export default __webpack_public_path__ + "static/media/BR - Host Analyst.7fbe512b.png";